<span *ngIf="group" [formGroup]="group">
  <span [ngClass]="{'disabled': disableSelector}">
    <ng-select [items]="items" bindValue="_id" bindLabel="name" [multiple]="true" [closeOnSelect]="false" [formControlName]="name">
    </ng-select>
  </span>
</span>